import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import icon from '../../assets/test.svg';

interface Option {
  label: string;
  value: number;
}

interface Question {
  question: string;
  options: Option[];
}

interface TestPageComponentProps {
  testType: string;
  title: string;
  description: string;
  questions: Question[];
  calculateScore: (answers: number[]) => number;
}

const TestPageComponent: React.FC<TestPageComponentProps> = ({
  testType,
  title,
  description,
  questions,
  calculateScore,
}) => {
  const navigate = useNavigate();
  const [answers, setAnswers] = useState<number[]>(Array(questions.length).fill(-1));

  const handleAnswerChange = (questionIndex: number, value: number) => {
    const newAnswers = [...answers];
    newAnswers[questionIndex] = value;
    setAnswers(newAnswers);
  };

  const isAllAnswered = answers.every(answer => answer !== -1);

  const handleSubmit = () => {
    if (!isAllAnswered) {
      alert('모든 문항에 답변해주세요.');
      return;
    }
    const totalScore = calculateScore(answers);
    navigate(`/tests/result?test=${testType}&score=${totalScore}`);
  };


  return (
    <div className="main-container">
      <div className="test-page">
        <div className="page-header">
          <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
          <h2 className="page-header__title">{title}</h2>
          <p className="page-header__subtitle">{description}</p>
        </div>
        <div className="test-questions">
          {questions.map((q, qIndex) => (
            <div key={qIndex} className="question-item">
              <p className="question-text">{q.question}</p>
              <div className={testType !== 'bdi' ? 'options-group' : 'options-group vertical'}>
                {q.options.map(opt => (
                  <label key={opt.value} className="radio-label">
                    <input
                      type="radio"
                      name={`question-${qIndex}`}
                      value={opt.value}
                      checked={answers[qIndex] === opt.value}
                      onChange={() => handleAnswerChange(qIndex, opt.value)}
                    />
                    <span className="radio-text">{opt.label}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
        <button onClick={handleSubmit} disabled={!isAllAnswered} className="submit-button">
          결과 보기
        </button>
      </div>
    </div>
  );
};

export default TestPageComponent;
